import { Box, LinkBox, LinkOverlay, Text } from '@cardboard-ui/react';
import React from 'react';
import { Layout, useActiveLayout } from 'utils/LayoutProvider';

const MobileSpaceShortcutDimensions = {
  height: '196px',
  width: '136px',
};

const DesktopSpaceShortcutDimensions = {
  height: '230px',
  width: '160px',
};

export const useSpaceShortcutDimensions = () => {
  const layout = useActiveLayout();
  const dimensions =
    layout === Layout.DESKTOP
      ? DesktopSpaceShortcutDimensions
      : MobileSpaceShortcutDimensions;
  return {
    ...dimensions,
    borderRadius: 5,
  };
};

export interface SpaceShortcutProps {
  url: string;
  title: string;
  imageURL: string;
  canModify?: boolean;
  editing?: boolean;
}

export const SpaceShortcutCard: React.FC<SpaceShortcutProps> = ({
  title,
  url,
  imageURL,
  canModify = false,
  editing = false,
}) => {
  const dimensions = useSpaceShortcutDimensions();
  const background = imageURL
    ? {
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4)),url('${imageURL}')`,
      }
    : { backgroundColor: 'gray.300' };

  return (
    <Box>
      <LinkBox>
        <LinkOverlay
          href={url}
          cursor={canModify ? 'move' : ''}
          onClick={(e) => {
            if (editing) {
              e.preventDefault();
              return false;
            }
            return true;
          }}
        >
          <Box {...dimensions} position="relative" overflow="hidden">
            <Box
              {...dimensions}
              backgroundPosition="center"
              backgroundRepeat="no-repeat"
              backgroundSize="cover"
              {...background}
            />

            <Text p={2} position="absolute" bottom={0} color="white">
              {title}
            </Text>
          </Box>
        </LinkOverlay>
      </LinkBox>
    </Box>
  );
};
